/* tslint:disable */
/* eslint-disable */
/**
 * Walnut Server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 4.148.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SettingsSchemaGeneralAccessibilityStandardFromJSON, SettingsSchemaGeneralAccessibilityStandardToJSON, } from './SettingsSchemaGeneralAccessibilityStandard';
import { SettingsSchemaGeneralAxeCoreVersionFromJSON, SettingsSchemaGeneralAxeCoreVersionToJSON, } from './SettingsSchemaGeneralAxeCoreVersion';
import { SettingsSchemaGeneralExpiredProductVisibilityFromJSON, SettingsSchemaGeneralExpiredProductVisibilityToJSON, } from './SettingsSchemaGeneralExpiredProductVisibility';
import { SettingsSchemaGeneralMlFromJSON, SettingsSchemaGeneralMlToJSON, } from './SettingsSchemaGeneralMl';
import { SettingsSchemaGeneralNeedsReviewFromJSON, SettingsSchemaGeneralNeedsReviewToJSON, } from './SettingsSchemaGeneralNeedsReview';
import { SettingsSchemaGeneralSharedReportAccessControlFromJSON, SettingsSchemaGeneralSharedReportAccessControlToJSON, } from './SettingsSchemaGeneralSharedReportAccessControl';
import { SettingsSchemaGeneralUsageServiceFromJSON, SettingsSchemaGeneralUsageServiceToJSON, } from './SettingsSchemaGeneralUsageService';
/**
 * Check if a given object implements the SettingsSchemaGeneral interface.
 */
export function instanceOfSettingsSchemaGeneral(value) {
    let isInstance = true;
    isInstance = isInstance && "accessibilityStandard" in value;
    isInstance = isInstance && "axeCoreVersion" in value;
    isInstance = isInstance && "needsReview" in value;
    isInstance = isInstance && "ml" in value;
    isInstance = isInstance && "bestPractices" in value;
    isInstance = isInstance && "experimentalRules" in value;
    isInstance = isInstance && "issueScreenshotSharing" in value;
    isInstance = isInstance && "sharedReportAccessControl" in value;
    isInstance = isInstance && "usageService" in value;
    isInstance = isInstance && "expiredProductVisibility" in value;
    return isInstance;
}
export function SettingsSchemaGeneralFromJSON(json) {
    return SettingsSchemaGeneralFromJSONTyped(json, false);
}
export function SettingsSchemaGeneralFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'accessibilityStandard': SettingsSchemaGeneralAccessibilityStandardFromJSON(json['accessibilityStandard']),
        'axeCoreVersion': SettingsSchemaGeneralAxeCoreVersionFromJSON(json['axeCoreVersion']),
        'needsReview': SettingsSchemaGeneralNeedsReviewFromJSON(json['needsReview']),
        'ml': SettingsSchemaGeneralMlFromJSON(json['ml']),
        'bestPractices': SettingsSchemaGeneralMlFromJSON(json['bestPractices']),
        'experimentalRules': SettingsSchemaGeneralMlFromJSON(json['experimentalRules']),
        'issueScreenshotSharing': SettingsSchemaGeneralMlFromJSON(json['issueScreenshotSharing']),
        'sharedReportAccessControl': SettingsSchemaGeneralSharedReportAccessControlFromJSON(json['sharedReportAccessControl']),
        'usageService': SettingsSchemaGeneralUsageServiceFromJSON(json['usageService']),
        'expiredProductVisibility': SettingsSchemaGeneralExpiredProductVisibilityFromJSON(json['expiredProductVisibility']),
    };
}
export function SettingsSchemaGeneralToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'accessibilityStandard': SettingsSchemaGeneralAccessibilityStandardToJSON(value.accessibilityStandard),
        'axeCoreVersion': SettingsSchemaGeneralAxeCoreVersionToJSON(value.axeCoreVersion),
        'needsReview': SettingsSchemaGeneralNeedsReviewToJSON(value.needsReview),
        'ml': SettingsSchemaGeneralMlToJSON(value.ml),
        'bestPractices': SettingsSchemaGeneralMlToJSON(value.bestPractices),
        'experimentalRules': SettingsSchemaGeneralMlToJSON(value.experimentalRules),
        'issueScreenshotSharing': SettingsSchemaGeneralMlToJSON(value.issueScreenshotSharing),
        'sharedReportAccessControl': SettingsSchemaGeneralSharedReportAccessControlToJSON(value.sharedReportAccessControl),
        'usageService': SettingsSchemaGeneralUsageServiceToJSON(value.usageService),
        'expiredProductVisibility': SettingsSchemaGeneralExpiredProductVisibilityToJSON(value.expiredProductVisibility),
    };
}
